import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useInstance, createVNode as h, directClone } from 'intact-react';
import { Option } from './option';
import { OptionGroup } from './group';
import { isNullOrUndefined, isStringOrNumber } from 'intact-shared';
import { getTextByChildren, mapChildren, isComponentVNode } from '../utils';
export function useFilterable(keywords) {
  var component = useInstance();
  function getCreatedVNode(children) {
    var _component$get = component.get(),
      creatable = _component$get.creatable,
      filterable = _component$get.filterable;
    var _keywords = keywords.value;
    if (creatable && filterable && _keywords) {
      if (!_findInstanceProperty(children).call(children, function (vNode) {
        // TODO: create Option for OptionGroup
        if (vNode.tag === Option) {
          var _context;
          var props = vNode.props;
          if (isNullOrUndefined(props)) return false;
          if (props.value === _keywords || _trimInstanceProperty(_context = props.label).call(_context) === _keywords) {
            return true;
          }
        }
        return false;
      })) {
        return h(Option, {
          value: _keywords,
          label: _keywords
        });
      }
    }
  }
  function filter(children) {
    var _component$get2 = component.get(),
      filterable = _component$get2.filterable,
      filter = _filterInstanceProperty(_component$get2),
      searchable = _component$get2.searchable;
    if (!filterable && !searchable) return children;
    if (isNullOrUndefined(filter)) {
      filter = defaultFilter;
    }
    var loop = function loop(children) {
      var _children = [];
      mapChildren(children, function (vNode) {
        if (isComponentVNode(vNode, Option)) {
          var props = vNode.props;
          if (isNullOrUndefined(props)) return;
          vNode = directClone(vNode);
          if (isNullOrUndefined(props.label)) {
            vNode.props = _extends({}, props, {
              label: getTextByChildren(props.children)
            });
          }
          var value = props.value;
          if (isStringOrNumber(value)) {
            vNode.key = value;
          }
          if (filter(keywords.value, vNode.props)) {
            _children.push(vNode);
          }
        } else if (isComponentVNode(vNode, OptionGroup)) {
          var _props = vNode.props;
          if (isNullOrUndefined(_props)) return;
          var _children2 = loop(_props.children);
          if (!_children2.length) return;
          vNode = directClone(vNode);
          vNode.props = _extends({}, _props, {
            children: _children2
          });
          _children.push(vNode);
        } else {
          _children.push(vNode);
        }
      });
      return _children;
    };
    return loop(children);
  }
  return {
    getCreatedVNode: getCreatedVNode,
    filter: filter
  };
}
function defaultFilter(keywords, props) {
  if (keywords === '') return true;
  keywords = keywords.toLowerCase();
  var label = props.label;
  if (!isNullOrUndefined(label) && ~label.toLowerCase().indexOf(keywords)) {
    return true;
  }
  var value = props.value;
  if (isStringOrNumber(value) && ~String(value).toLowerCase().indexOf(keywords)) {
    return true;
  }
  return false;
}